exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.inputFields[data-v-0e76d633] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 40px;\n}\n", "", {"version":3,"sources":["/usr/src/app/node_modules/@intelipost-modules/secure-integrations/features/integrations-app-v2/components/input-fields/InputFields.vue"],"names":[],"mappings":";AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,UAAU;CACX","file":"InputFields.vue","sourcesContent":["\n.inputFields[data-v-0e76d633] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 40px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0e76d633","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/@intelipost-modules/secure-integrations/features/integrations-app-v2/components/input-fields/InputFields.vue
// module id = bRXC
// module chunks = 72